import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './samplereports.css'
import ReportIcon from '@mui/icons-material/Report';
import DownloadingIcon from '@mui/icons-material/Downloading';
import Callbackpopup from '../callbackpopup/Callbackpopup';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const SampleReports = ({popupType}) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [cardItemValue, setCardItemValue] = useState('');
  const [isFeaturesExpanded, setIsFeaturesExpanded] = useState(false);

  const openPopup = (cardItemName) => {
    setPopupOpen(true);
    setCardItemValue(cardItemName);
    document.body.style.overflow = 'hidden';
  };

  const closePopup = () => {
    setPopupOpen(false);
    document.body.style.overflow = 'auto';
  };

  const reportFeatures = [
    "Inspected Apartment Details",
    "Detailed observations and locations of all identified snags",
    "Expert suggestions for resolving each snag",
    "Summary of snags organized by location",
    "Details of the inspector with authorized signature",
    "High-resolution images for clear proof"
  ];

  const reportStats = [
    { number: "100+", label: "Defects Identified" },
    { number: "100+", label: "High-Res Images" },
    { number: "24hrs", label: "Report Delivery" },
    { number: "100%", label: "Accuracy Guaranteed" }
  ];

  return (
    <div className="sample-reports-card">
      <div className="sample-reports-header">
        <div className="sample-reports-badge">
          <PictureAsPdfIcon className="badge-icon" />
          <span>Professional Reports</span>
        </div>
        <h1 className="sample-reports-title">Home Inspection Reports</h1>
        <p className="sample-reports-description">
          Receive a detailed explanation of all snags in your home, complete with high-resolution images for clear proof!
        </p>
      </div>

      <div className="report-content">
        <div className="report-card-header">
          <div className="report-icon">
            <ReportIcon className="card-icon" />
          </div>
          <h2 className="report-card-title">Detailed Snag Report Includes</h2>
        </div>
        
        <div className="report-description">
          <p>Our comprehensive inspection reports provide you with everything you need to understand and address every defect in your new home.</p>
        </div>

        <div className={`report-features ${!isFeaturesExpanded ? 'collapsed' : ''}`}>
          <div 
            className="features-header" 
            onClick={() => setIsFeaturesExpanded(!isFeaturesExpanded)}
          >
            <h3 className="features-title">What's Included in the Report:</h3>
            {isFeaturesExpanded ? (
              <ExpandLessIcon className="expand-icon" />
            ) : (
              <ExpandMoreIcon className="expand-icon" />
            )}
          </div>
          <div className={`features-content ${isFeaturesExpanded ? 'expanded' : 'collapsed'}`}>
            <div className="features-grid">
              {reportFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <CheckCircleIcon className="feature-icon" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="report-stats">
          <h3 className="stats-title">Report Statistics</h3>
          <div className="stats-grid">
            {reportStats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="report-benefits">
          <div className="benefit-item">
            <div className="benefit-icon">📊</div>
            <div className="benefit-text">
              <h4>Comprehensive Analysis</h4>
              <p>Every corner of your home thoroughly inspected</p>
            </div>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">📸</div>
            <div className="benefit-text">
              <h4>Visual Documentation</h4>
              <p>High-resolution images for every identified issue</p>
            </div>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">⚡</div>
            <div className="benefit-text">
              <h4>Quick Delivery</h4>
              <p>Receive your report within 24 hours</p>
            </div>
          </div>
        </div>

        <div className="report-cta">
          <button 
            className="sample-button" 
            onClick={() => openPopup("Get Sample Report On Your Mobile")}
          >
            <DownloadingIcon className="button-icon" />
            <span>Get Sample Report</span>
            <ArrowForwardIcon className="button-arrow" />
          </button>
          <p className="sample-note">View sample report instantly on your mobile</p>
        </div>
      </div>
      {isPopupOpen && createPortal(
        <Callbackpopup onClose={closePopup} cardItem={cardItemValue}/>,
        document.body
      )}
    </div>
  )
}

export default SampleReports
